import { render, staticRenderFns } from "./xlElevator.vue?vue&type=template&id=01102c74&scoped=true&"
import script from "./xlElevator.vue?vue&type=script&lang=js&"
export * from "./xlElevator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01102c74",
  null
  
)

export default component.exports